import React, { Component } from 'react'
import { Layout, Row, Col, Menu, Button, List, Card, Tooltip, Icon, Pagination, Popconfirm, InputNumber, Modal, Checkbox, Collapse } from 'antd'
import { Link, Redirect } from 'react-router-dom'
import Head from '../../components/Head'
import ICP from '../../components/ICP'
import Foote from '../../components/Footer'
import Iconz from '../../components/Iconz'
import XZS from '../../components/XZS'
import PayTemplate from '../../components/PayTemplate'
import utils from '../../utils'
import { api, app } from '../../app'
import config from '../../config'
import common from './common'
import '../../css/cart.css';

const { Content } = Layout
const { Panel } = Collapse;

const order_state = common.order_state

class CartList extends Component {
    constructor(props) {
        super(props)
        this.state = {
            menu_current: '10',
            orderList: [],
            page: 1,
            total: 1,
            currentNumValue: '', // 当前输入数量的值
            currentGoodValue: {}, // 
            selectInfo: {
                count: 0,
                money: 0
            },
            select_all: false, // 是否全选
            addressTypeArr: [],
            isSelectBig2: false, // 选中得项是否大于2
            isTeam: false, // 是否选中了制式装备 false 普通商品 true 制式装备
            style: {},
            showSettlmentBox: false, // 是否显示结算页
            addressList: [], // 地址数据
            addressi: '', // 当前选中地址
            addressi2: '', // 当前选中地址2
            addressi3: '', // 当前选中地址3
            openMoreAddressStatus: false,
            pay_loading: false, // 支付状态
            address_remark: '', // 地址备注
        }
    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll, true);
        this._isMounted = true
        this.DataList(1);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll, true);
        this._isMounted = false
    }

    setData = (data) => app.setStateSync(this, data)

    handleScroll = (e) => {
        if (document.getElementById('footer')) {
            let clientHeight2 = document.getElementById('footer').clientHeight;
            let ctx = this;
            let a = e.srcElement.clientHeight - clientHeight2 - 44;
            if (e.srcElement.scrollTop > a || e.srcElement.scrollTop == a) {
                ctx.setState({ style: { position: "relative", } })
            } else {
                ctx.setState({ style: { position: "fixed", } })
            }
        }
    }

    // 提交订单
    handlePay = async () => {
        const { pay_loading, addressList, orderList } = this.state;
        if (pay_loading) return false
        let address_i = {};

        // 获取选中的收货地址
        addressList.forEach(e => {
            if (e.status) {
                address_i = e;
            }
        })

        let info = []
        // 获取选中的商品
        orderList.forEach(e => {
            if (e.product_info != '' || e.product_info != undefined) {
                e.product_info.forEach(ex => {
                    if (ex.sel) {
                        let obj = {
                            mall_id: ex.product_id,
                            number: ex.number,
                            money: ex.price,
                            sku_id: ex.sku_id,
                        }
                        info.push(obj);
                    }
                })
            }
        })
        // const { sel_spec } = this.state;

        if (address_i == '' || address_i == {}) {
            app.alert('请添加收货地址', 'warn')
            return false
        }
        app.alert('正在加载...', 'loading', '50%', 0)
        await this.setData({ pay_loading: true })
        // let sss = values.number || 1;
        // let number = parseFloat(this.state.specSprice).toFixed(2) || 1;
        // console.log(this.state.specSprice);
        // console.log(values.number);
        // console.log(number);
        debugger
        const params = {
            indexno: app.getData('indexno'),
            account: app.getData('account'),
            name: address_i.receiver_name,
            mobile: address_i.receiver_mobile,
            address: address_i.province + address_i.city + address_i.district + address_i.receiver_address,
            message: '',
            is_cart: 1,
        };
        params.info = JSON.stringify(info)
        // console.log(params);

        const { flag, data, msg } = await app.post(api.MallPay, params)
        app.alertDestroy()
        if (flag === 1) {
            Modal.confirm({
                title: '扫码支付',
                centered: true,
                icon: (<Icon type="alipay-circle" style={{ color: '#00A1E9' }} />),
                width: 600,
                content: (
                    <PayTemplate qrcode={data.qrUrl} money={data.totalAmount.toFixed(2)} no={data.orderCode} />),
                okText: '已支付',
                cancelText: '关闭',
                onOk: async () => {
                    const { flag, msg } = await app.post(api.MConfirmPay, {
                        indexno: app.getData('indexno'),
                        account: app.getData('account'),
                        order_code: data.ordersNo
                    })
                    if (flag === 1) {
                        app.alert('支付成功', 'success')
                        this.props.history.push('/mall/orders')
                        return true
                    } else {
                        app.alert(msg, 'warn')
                        throw false
                    }
                },
                onCancel: async () => {
                    this.closeTheSettlment();
                    await this.DataList(1);
                }

            })
        } else {
            app.alert(msg, 'warn')
        }
        await this.setData({ pay_loading: false })
    }

    /**
     * 删除
     * @param orders_no
     * @returns {Promise<boolean>}
     */
    handleCancel = async (orders_id) => {
        let params = {
            indexno: app.getData('indexno'),
            account: app.getData('account'),
            id: orders_id,
        };
        const { flag, msg } = await app.post(api.CartDel, params)
        if (flag === 1) {
            app.alert(msg, 'success')
        }
        await this.setData({ page: 1 })
        await this.DataList(1)
    }

    // 设置购物车数量
    setCartNum = async (e) => {
        console.log(e);
        await this.setData({ currentNumValue: e })
        // setInterval(() => {

        // }, 100);
    }

    // 获得焦点事件
    onFoucsChange = (e, a, b) => {
        console.log(e);
        this.setData({ currentGoodValue: e })
    }

    // 失焦事件
    onBlurChange = async () => {
        app.alert("loading", "loading");
        await this.setGoodNum(this.state.currentNumValue);
    }

    // 设置购物车商品购买数量
    setGoodNum = async (e) => {
        const { currentGoodValue } = this.state;
        if (e == '' || e == undefined) {

        } else {
            let params = {
                indexno: app.getData('indexno'),
                account: app.getData('account'),
                id: currentGoodValue.id,
                product_id: currentGoodValue.product_id,
                number: e,
            };
            const { flag, msg } = await app.post(api.CartEdit, params)
            if (flag === 1) {
                app.alert(msg, 'success')
                this.setData({
                    currentNumValue: 0,
                    currentGoodValue: {},
                    selectInfo: {
                        count: 0,
                        money: 0
                    },
                    select_all: false, // 是否全选
                    addressTypeArr: [],
                })
            } else {
                app.alert(msg, 'warn')
            }
            await this.setData({ page: 1 })
            await this.DataList(1)
        }
    }

    /**
     * 确认收货
     * @returns {boolean}
     */
    handleConfirmOrder = async (orders_id) => {
        app.alert('确认收货中...', 'loading', '45%', 0)
        const params = {
            orders_id,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        }
        let { flag, msg } = await app.post(api.MyOrdersConfirmReceipt, params)
        app.alertDestroy()
        if (flag === 1) {
            app.alert('确认成功', 'success')
            await this.setData({ page: 1 })
            await this.DataList(1)
        } else {
            app.alert(msg, 'warn')
        }
    }

    // 删除选中商品
    delSelectGood = async () => {
        const { orderList, select_all, isSelectBig2 } = this.state;
        if (select_all || isSelectBig2) {
            let arr = [];
            orderList.forEach(good => {
                if (good.product_info != undefined && good.product_info != '') {
                    good.product_info.forEach(good2 => {
                        if (good2.sel) {
                            arr.push(good2.id);
                        }
                    })
                }
            });
            const params = {
                id: arr.join(),
                indexno: app.getData('indexno'),
                account: app.getData('account'),
            }

            let { flag, msg } = await app.post(api.CartDel, params)
            if (flag === 1) {
                app.alert(msg, 'success');
                await this.setData({
                    currentNumValue: '', // 当前输入数量的值
                    selectInfo: {
                        count: 0,
                        money: 0
                    },
                    select_all: false, // 是否全选
                    isSelectBig2: false,
                    addressTypeArr: [],
                })
                await this.DataList(1);
            } else {
                app.alert(msg, 'warn');
            }

        }
    }

    // 全选所有商品
    selectAllOptions = async () => {
        // const {orderList} = this.state;
        // orderList.forEach(e=>{
        //     if (e.product_info != '' && e.product_info != undefined) {
        //         e.product_info.forEach(k=>{
        //             k.
        //         })
        //     }
        // })

        // 步骤1：先判断是否包含了制式装备和其他商品
        const { orderList } = this.state;

        let a = ''; // 代表制式装备
        let b = ''; // 代表其他商品
        let c = ''; // 代表地址 1为队部地址 2个人地址
        orderList.forEach(good => {
            if (good.product_info != undefined && good.product_info != '') {
                good.product_info.forEach(good2 => {
                    if (good2.is_team == 1) {
                        a = 1;
                    } else {
                        b = 2;
                    }
                })
            }
        });
        // 相等即代表选择的商品都是制式装备or其他商品，否则不允许全选
        if (a == 1 && b != 2) {
            // 全是制式装备
            c = 2;
        } else if (a == '' && b == 2) {
            // 全是其他商品
            c = 1;
        }

        if (c != '') {
            // 步骤2：获取地址信息
            const select_all = !this.state.select_all;
            orderList.forEach((good) => {
                if (good.product_info != undefined && good.product_info != '') {
                    good.product_info.forEach(good2 => {
                        good2.sel = select_all; // 全选状态下给所有商品都加上勾选状态             
                    })
                }
            });
            this.setData({
                select_all: select_all,
                isSelectBig2: select_all,
                // addressType: c
            })
            await this.calcInfo();
        } else {
            app.alert("制式装备和其它商品不允许一起下单，发货和收货方式不一致", "warn");
            // 步骤2：获取地址信息
            // const select_all = !this.state.select_all;
            // orderList.forEach((good) => {
            //     if (good.product_info != undefined && good.product_info != '') {
            //         good.product_info.forEach(good2=>{
            //             good2.sel = select_all; // 全选状态下给所有商品都加上勾选状态              
            //         })
            //     }
            // });
            // this.setData({
            //     select_all: select_all,
            //     isSelectBig2: select_all,
            //     // addressType: c
            // })
            // await this.calcInfo();
            // if (!editStatus) {
            // app.alert("制式装备和其它商品不允许一起下单，发货和收货方式不一致");
            // this.showTip = true;
            // this.tip = '制式装备和其它商品不允许一起下单，发货和收货方式不一致';
            // setTimeout(() => {
            //     this.showTip = false;
            //     this.tip = '';
            //     this.$apply();
            // }, 1500);
            // } else {

            // }
        }
    }

    // 单选
    handleSel = (i1, i2) => {
        const { orderList, addressTypeArr } = this.state;
        let arra = addressTypeArr;
        // console.log('start: '+this.addressType);
        let a = orderList;
        a.forEach((e, i) => {
            if (i == i1) {
                e.product_info.forEach((ae, ai) => {
                    if (ai == i2) {
                        if (ae.sel) {
                            arra.pop();
                        } else {
                            arra.push(ae.is_team);
                        }
                    }
                })
            }
        })
        let isTrue = true;
        let len = arra.length;
        let isSelectBig2 = false;
        if (len > 1) {
            isSelectBig2 = true;
            // 最后一个值不等于倒数第二个值
            if (arra[len - 1] != arra[len - 2]) {
                // app.alert('');
                app.alert("制式装备和其它商品不允许一起下单，发货和收货方式不一致", "warn");
                arra.pop();
                isTrue = false;
            }
        }
        if (isTrue) {

            a.forEach((e, i) => {
                if (i == i1) {
                    e.product_info.forEach((ae, ai) => {
                        if (ai == i2) {
                            if (ae.sel) {
                                ae.sel = false;
                            } else {
                                ae.sel = true;
                            }
                        }
                    })
                }
            })
            this.setData({
                addressTypeArr: arra,
                isSelectBig2: isSelectBig2
            })
            this.calcInfo();
        } else {
            this.setData({
                isSelectBig2: false
            })
        }
    }

    // 计算器
    calcInfo = async () => {
        const { orderList } = this.state;
        // 初始化选择状态，然后开始计算
        let select_all = true, selectInfo = { count: 0, money: 0 };
        orderList.forEach((good) => {
            if (good.product_info != undefined && good.product_info != '') {
                good.product_info.forEach(good2 => {
                    if (!good2.sel) {
                        select_all = false; // 如果有一个为false都不是全选
                    } else {
                        // 仅计算已勾选的商品
                        selectInfo.count++;
                        selectInfo.money += Number(good2.total_price);
                        // console.log(good2.total_price)
                    }
                })
            }
        });
        // console.log()
        selectInfo.money = selectInfo.money.toFixed(2);
        await this.setData({
            select_all: select_all,
            selectInfo: selectInfo
        })
    }

    /**
     * 数据
     * @param page
     */
    DataList = async (page) => {
        await this.setData({ data_loading: true })
        const { menu_current } = this.state, params = {
            page,
            status: menu_current,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        }

        let { flag, data, msg, total = 0 } = await app.post(api.CartData, params)
        if (flag !== 1) {
            app.alert(msg, 'warn')
            data = []
        } else {
            let a = data;
            let b = this.state.orderList;
            a.forEach((e, i) => {
                if (e.product_info != undefined && e.product_info != '') {
                    e.product_info.forEach((e2, i2) => {
                        e2.sel = false; // 初始化未选中状态
                    })
                }
            });
            b = b.concat(a);
            // utils.addArrayKey(b)
            await this.setData({ orderList: utils.addArrayKey(a), total: parseInt(total || 0), data_loading: false })
        }
    }

    /**
     * 菜单点击
     * @param e
     */
    handleMenuClick = async (e) => {
        await this.setData({ menu_current: e.key, page: 1 })
        await this.DataList(1)
    }

    /**
     * 分页
     *
     **/
    handlePageChange = async (page) => {
        await this.setData({ page })
        await this.DataList(page)
    }

    // 去结算
    toSettlment = async () => {

        const { orderList } = this.state;
        let arr = [];
        var a = ''; // 选中商品地址的类型（队部地址、个人地址）
        let b = false; // 是否选中的是制式装备 false 不是 true 是
        let c = ''; // 地址备注
        orderList.forEach((e, ei) => {
            if (e.product_info != undefined && e.product_info != '') {
                e.product_info.forEach(e2 => {
                    if (e2.sel) {
                        // 获取地址备注
                        c = e2.address_remark;
                        // 判断选中商品为制式装备还是普通商品
                        if (e2.is_team == 1) {
                            b = true;
                        } else {
                            b = false;
                        }
                        arr.push({
                            id: e2.id,
                            number: e2.number
                        });
                        if (e2.is_team == 0) {
                            a = 1;
                        } else {
                            a = 2;
                        }
                    }
                })
            }
        })

        if (arr.length > 0) {
            await this.getAddress(a);
            setTimeout(() => {
                this.setData({
                    showSettlmentBox: true,
                    isTeam: b,
                    address_remark: c,
                });
                window.removeEventListener('scroll', this.handleScroll, true);
            }, 500);
        } else {
            app.alert("请至少选择一个商品", "warn");
        }
        // console.log(arr);
    }

    // 关闭结算页
    closeTheSettlment = () => {
        window.addEventListener('scroll', this.handleScroll, true);
        this.setData({
            showSettlmentBox: false,
            addressList: [],
            addressi: '',
            addressi2: '',
        })
    }

    // 是否新增地址
    isAddAddress = () => {
        this.props.history.push('/player/user-address')
    }

    // 赋值选中地址
    setAddress2 = async (e) => {
        console.log(e);
        const { addressList } = this.state;
        let addressi3 = {};
        addressList.forEach(ew => {
            if (e.receiver_id == ew.receiver_id) {
                ew.status = true;
                addressi3 = ew;
            } else {
                ew.status = false;
            }
        })

        var arr = addressList

        for (var i = 0; i < arr.length; i++) {
            if (arr[i].status) {
                var obj = arr[i];
                arr.splice(i, 1);
                break
            }
        }

        arr.unshift(obj);

        await this.setData({
            addressi: '寄送至：' + e.province + " " + e.city + " " + e.district + " " + e.receiver_address + " " + '收货人：' + e.receiver_name + " " + e.receiver_mobile,
            addressi2: e.receiver_name + " " + e.province + " " + e.city + " " + e.district + " " + e.receiver_address + " " + e.receiver_mobile,
            addressi3: addressi3,
            openMoreAddressStatus: false,
            addressList: arr,
        });

    }

    // 获取地址（队部or各人地址）
    getAddress = (ee) => {
        const _this = this;
        let params = {
            account: app.getData('account'),
            indexno: app.getData('indexno'),
            type: ee,
        }
        app.post(api.UserAddress, params).then(({ flag, data, msg }) => {
            if (_this._isMounted) {
                if (flag === 1) {
                    let addressi, addressi2, addressi3 = '';
                    if (data.length > 0) {
                        data.forEach(e => {
                            e.status = e.receiver_default == 1 ? true : false
                        })
                        addressi = '寄送至：' + data[0].province + " " + data[0].city + " " + data[0].district + " " + data[0].receiver_address + " " + '收货人：' + data[0].receiver_name + " " + data[0].receiver_mobile;
                        addressi2 = data[0].receiver_name + " " + data[0].province + " " + data[0].city + " " + data[0].district + " " + data[0].receiver_address + " " + data[0].receiver_mobile;
                        addressi3 = {
                            receiver_name: data[0].receiver_name,
                            province: data[0].province,
                            city: data[0].city,
                            district: data[0].district,
                            receiver_address: data[0].receiver_address,
                            receiver_mobile: data[0].receiver_mobile,
                        }
                    }
                    _this.setState({ addressList: data, addressi: addressi, addressi2: addressi2, addressi3: addressi3 });
                } else {
                    app.alert(msg, "error");
                    setTimeout(() => {
                        _this.setState({ showSettlmentBox: false, addressList: [], addressi: '', addressi2: "" });
                    }, 1000);
                }
            }
        });
    }

    // 是否打开更多地址
    setOpenMoreAddressStatus = async () => {
        const { openMoreAddressStatus } = this.state;
        if (openMoreAddressStatus) {
            await this.setData({
                openMoreAddressStatus: false,
            })
        } else {
            await this.setData({
                openMoreAddressStatus: true,
            })
        }
    }

    render() {
        console.log("???");
        let isLogin = app.checkLogin()
        if (isLogin) {
            return (<Redirect to="/" />)
        } else {
            let { orderList, data_loading, addressi3, pay_loading, menu_current, total, address_remark, page, openMoreAddressStatus, isTeam, selectInfo, addressi, addressi2, select_all, showSettlmentBox, isSelectBig2, addressList } = this.state,
                { history } = this.props;

            // 结算页面底部
            const Footer2 = () => {
                return (
                    <div style={{ display: 'flex', justifyContent: 'end', flexDirection: 'column' }}>
                        <h6 style={{ paddingRight: '16px' }}><span style={{ marginRight: '20px' }}>总金额：</span> <span style={{ fontSize: '14px', }}>￥ {selectInfo.money}</span> </h6>
                        <div style={{ padding: '10px 16px', background: '#f2f2f2', margin: '10px 0' }}>
                            <h6 style={{ textAlign: 'left', width: '100%' }}>
                                寄送至：{addressi3.province} {addressi3.city} {addressi3.district} {addressi3.receiver_address}
                            </h6>
                            <h6 style={{ textAlign: 'left', width: '100%' }}>
                                收货人：{addressi3.receiver_name}  {addressi3.receiver_mobile}
                            </h6>
                            <h6 style={{ textAlign: 'left', color: 'red', width: '100%' }}>{address_remark}</h6>
                        </div>
                        <div style={{ padding: '10px 16px', background: '#f2f2f2', margin: '10px 0' }}>
                            <h6 style={{ textAlign: 'right', width: '100%' }}><span style={{ marginRight: '20px' }}>应付总额：</span>￥ <span style={{ fontSize: '24px', color: 'red' }}>{selectInfo.money}</span> </h6>
                        </div>
                        <div>
                            <Button type='primary' onClick={() => this.handlePay()} loading={pay_loading}>提交订单</Button>
                        </div>
                    </div>
                )
            }

            return (
                <Layout className='mall-order-list'>
                    <Head notLogin={(
                        <div className="frame-head-logo">
                            <Iconz type="icon-logo_" size={48} />
                        </div>
                    )} background="#3F89C1" height={78} history={history} />
                    <Content>
                        <div className="order-content" style={{ padding: '0' }}>
                            {/* <div className="order-menu">
                            <Menu
                                onClick={this.handleMenuClick}
                                selectedKeys={[menu_current]}
                                mode="horizontal"
                            >
                                {
                                    order_state.map((os) => {
                                        return ['4', '6', '7', '8'].indexOf(os.id) > -1 ? null : (
                                            <Menu.Item key={os.id}>{os.name}</Menu.Item>)
                                    })
                                }
                            </Menu>
                        </div> */}
                            {/*<div className="order-filter">*/}
                            {/*<Input.Search placeholder="输入商品标题或订单号进行搜索" enterButton={<Button>订单搜索</Button>}/>*/}
                            {/*</div>*/}
                            <List
                                className='listBox'
                                size="small"
                                header={
                                    <Row className="list-head" style={{ textAlign: 'left' }} gutter={[10, 32]} type="flex">
                                        <Col style={{ width: '138px', paddingLeft: '6px' }}>
                                            {/* <input style={{ marginLeft: '6px', }} className='checkbox_all' type="checkbox" /> */}
                                            <Checkbox onChange={() => this.selectAllOptions()} checked={select_all}>全选</Checkbox>
                                        </Col>
                                        <Col style={{ width: 'calc(70% - 198px)' }}>商品</Col>
                                        <Col style={{ width: '10%', textAlign: 'center' }}>单价</Col>
                                        <Col style={{ width: '10%', textAlign: 'center' }}>数量</Col>
                                        <Col style={{ width: '10%', textAlign: 'center' }}>小计</Col>
                                        {/* <Col style={{ width: '15%' }}>交易状态</Col> */}
                                        <Col style={{ width: '60px', textAlign: 'center' }}>操作</Col>
                                    </Row>
                                }
                                locale={{ emptyText: '购物车空空如也' }}
                                footer={
                                    <div className="pagination">
                                        <Pagination size="small" total={total} pageSize={20}
                                            current={page}
                                            hideOnSinglePage={true}
                                            showTotal={(total) => `总数量：${total}`}
                                            onChange={(page) => this.handlePageChange(page)} />
                                    </div>
                                }
                                dataSource={orderList}
                                renderItem={(item, itemidex) => {
                                    return (
                                        <List.Item>
                                            <Card
                                                // title={
                                                //     <div
                                                //         style={{
                                                //             display: 'flex',
                                                //             justifyContent: 'space-between',
                                                //         }}
                                                //     // onClick={() => history.push('/mall/order-detail/' + item.orders_id)}
                                                //     >
                                                //         <div style={{ width: '70%' }}>
                                                //             <input className='checkbox_all' type="checkbox" />
                                                //             <span>订单号：{item.out_trade_no}</span>
                                                //         </div>
                                                //         <span>{item.datetime}</span>
                                                //     </div>
                                                // }
                                                title={false}
                                                headStyle={{ padding: '0 6px' }}
                                                style={{ width: '100%' }}
                                                bodyStyle={{ padding: 0 }}
                                            >
                                                <Row className="list-content1" type="flex" gutter={10}
                                                    style={{ display: 'block' }}
                                                >
                                                    {
                                                        (item.product_info || []).map((good, i) => {
                                                            return (
                                                                <Row gutter={10} type="flex" key={i}
                                                                    className="good r-b"
                                                                    style={{ position: 'relative', left: '-3px' }}
                                                                // onClick={() => history.push('/mall/order-detail/' + item.orders_id)}
                                                                >
                                                                    <Col style={{ marginLeft: '16px' }}>
                                                                        {/* <input value={item.sel} onChange={(e)=>console.log(e)} type="checkbox" /> */}
                                                                        <Checkbox checked={good.sel} onChange={() => this.handleSel(itemidex, i)}></Checkbox>
                                                                    </Col>
                                                                    <Col style={{ width: 'calc(70% - 97px)', }}>
                                                                        <Row className="good-info" type="flex">
                                                                            <div className="good-img" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                                <a href="javascript:;" style={{ width: '100%', height: '100%' }}>
                                                                                    <img src={config.imgUrl + good.product_img} alt="" />
                                                                                </a>
                                                                            </div>
                                                                            <div className="good-name">
                                                                                <p><a
                                                                                    href="javascript:;">{good.product_name} <span style={{ color: good.is_team == 1 ? 'red' : '' }}>{good.is_team == 1 ? '(制式装备)' : ''}</span> </a>
                                                                                </p>
                                                                                <p>
                                                                                    <span style={{ background: good.sku_content_name == '' || good.sku_content_name == null ? '' : '#f2f2f2', padding: '2px 4px', borderRadius: '4px', display: 'inlin-block' }}>{good.sku_content_name}</span>
                                                                                </p>
                                                                                <p>{good.details_huopin_content}</p>
                                                                            </div>
                                                                        </Row>
                                                                    </Col>
                                                                    <Col style={{ width: '10%', }} className="p-t-201">{good.price}</Col>
                                                                    <Col style={{ width: '10%', }} className="p-t-201">
                                                                        <InputNumber onFocus={() => this.onFoucsChange(good, itemidex, i)} onBlur={() => this.onBlurChange()} onChange={(e) => this.setCartNum(e)} min={0} addonBefore="+" addonAfter="-" disabled={good.number == 0} defaultValue={good.number == 0 ? '库存不足' : good.number} />
                                                                    </Col>
                                                                    <Col style={{ width: '10%', }} className="r-b p-t-201">{good.total_price}</Col>
                                                                    <Col style={{ width: '55px' }} className="r-b p-t-201">
                                                                        <p>
                                                                            <Popconfirm title="是否删除该商品！"
                                                                                onConfirm={() => this.handleCancel(good.id)}
                                                                                okText="是" cancelText="否">
                                                                                <a style={{ color: good.sel ? 'red' : '#ccc' }} href="javascript:;">删除</a>
                                                                            </Popconfirm>
                                                                        </p>
                                                                    </Col>
                                                                </Row>
                                                            )
                                                        })
                                                    }
                                                </Row>
                                            </Card>
                                        </List.Item>
                                    )
                                }}
                            />
                            {/*<Table loading={data_loading} columns={columns} locale={locale}*/}
                            {/*dataSource={orderList} pagination={false} size="small"/>*/}
                        </div>
                        {/* 底部 */}
                        <div className='order-footer' style={this.state.style}>
                            <div className='order-footer-box'>
                                <div className='order-footer-left'>
                                    <Checkbox onChange={() => this.selectAllOptions()} checked={select_all}>全选</Checkbox>
                                    {/* <input onClick={()=>this.selectAllOptions()} type="checkbox" style={{position: 'relative', top: '2px'}} /> 全选 */}
                                    <span onClick={() => this.delSelectGood()} style={{ color: !isSelectBig2 ? '#ccc' : 'red' }}>删除选中的商品</span>
                                </div>
                                <div className='order-footer-right'>
                                    已选择 <span style={{ color: 'red', fontSize: '20px' }}>{selectInfo.count}</span> 件商品 总价：<span style={{ color: 'red', fontSize: '20px', fontWeight: 'bold', display: 'inline-block', marginRight: '5px' }}>￥{selectInfo.money}</span>
                                    <div onClick={() => this.toSettlment()} className='order-footer-btn'>去结算</div>
                                </div>
                            </div>
                        </div>
                        <div style={{ height: '25px' }}></div>
                        <div id="footer">
                            <Foote />
                        </div>
                        <ICP bg="#434343" />
                    </Content>
                    <XZS />
                    <Modal
                        title="结算页"
                        visible={this.state.showSettlmentBox}
                        footer={Footer2()}
                        width="768px"
                        onCancel={() => this.closeTheSettlment()}
                    >

                        <h4 style={{ display: 'flex', justifyContent: 'space-between' }}>填写并核对订单信息
                            <span style={{ display: isTeam ? 'none' : 'inline-block', color: '#1890ff', cursor: 'pointer', paddingRight: '14px' }} onClick={() => this.isAddAddress()}>新增地址<Icon type="plus" /></span>
                        </h4>

                        <div style={{ border: '1px solid #e8e8e8', marginBottom: '12px' }}>
                            <div style={{ padding: '12px' }}><span style={{ paddingRight: '6px' }}>收货人：</span>
                                {addressi3.receiver_name} {addressi3.receiver_mobile}
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', padding: '12px' }}>
                                <span style={{ wordBreak: 'break-all' }}>收货地址: {addressi3.province} {addressi3.city} {addressi3.district} {addressi3.receiver_address}</span>
                                <span onClick={() => this.setOpenMoreAddressStatus()} style={{ cursor: 'pointer', color: '#1890ff', minWidth: '100px', textAlign: 'right' }}>{!openMoreAddressStatus ? '更换地址' : '收起地址'}
                                    <Icon type="double-left" style={{ display: 'inline-block', transform: !openMoreAddressStatus ? 'rotate(270deg)' : 'rotate(90deg)' }} />
                                </span>
                            </div>
                        </div>

                        <div className='settlmentBox-bg' style={{ height: !openMoreAddressStatus ? '0' : '200px', overflowY: 'scroll' }}>
                            {
                                (addressList || []).map((e, i) => {
                                    return (
                                        <div className='settlmentBox' key={i} onClick={() => this.setAddress2(e)}>
                                            <span style={{ padding: '2px 6px', marginRight: '10px', borderRadius: '2px', border: e.status ? '2px solid #1890ff' : 'none', lineHeight: '30px', height: '30px' }}> {e.receiver_name} {e.province}</span>
                                            {/* <Tooltip title={<span>{e.receiver_name} {e.province} {e.city} {e.district} {e.receiver_address} {e.receiver_mobile}</span>}>
                                            </Tooltip> */}
                                            <span>{e.receiver_name} {e.province} {e.city} {e.district} {e.receiver_address} {e.receiver_mobile}</span>
                                            <span style={{ padding: '2px 4px', color: 'red', display: e.receiver_default == 1 ? 'inline-block' : 'none', marginLeft: '10px' }}>(默认地址)</span>
                                        </div>
                                    )
                                })
                            }
                        </div>
                        {/* <Card
                            title={}
                            extra={<div onClick={()=>this.setOpenMoreAddressStatus()} style={{ cursor: 'pointer' }}>更换地址</div>}
                            // extra={<div style={{ paddingLeft: '6px', cursor: 'pointer' }} onClick={() => addressi2 == '' ? this.isAddAddress() : this.setOpenMoreAddressStatus()}>{addressi2 == '' ? '新增地址' : (openMoreAddressStatus ? '收起地址' : '更多地址')}</div>}
                            size="small"
                        >
                            
                        </Card> */}
                        <Card
                            title="商品详情"
                            size="small"
                            style={{ marginTop: '12px' }}
                        >
                            {(orderList || []).map((e, i) => {
                                return (
                                    <div key={i}>
                                        {(e.product_info || []).map((e2, i2) => {
                                            return (
                                                <div className='goodDetailBox' key={i2} style={{ display: e2.sel ? 'flex' : 'none' }}>
                                                    <div className='goodDetailBox_imgBox'>
                                                        <img src={config.imgUrl + e2.product_img} alt="" className='goodDetailBox_img' />
                                                    </div>
                                                    <div className='goodDetailBox_item'>
                                                        <div className='goodDetailBox_title'>
                                                            <div className="sku_content_name">{e2.sku_content_name}</div>
                                                            <div className="product_name">{e2.product_name}</div>
                                                        </div>
                                                        <div className='goodDetailBox_price'>￥{e2.price}</div>
                                                        <div className='goodDetailBox_num'>x {e2.number}</div>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </div>
                                )
                            })}
                        </Card>
                        {/* <Collapse 
                            defaultActiveKey={['2']} 
                            ghost
                        >
                            <Panel 
                            header="收货人信息" 
                            key="1"
                            >
                                
                            </Panel>
                            <Panel header="商品详情" key="2">
                                
                            </Panel>
                        </Collapse> */}
                    </Modal>
                </Layout>
            )
        }
    }
}

export default CartList



// WEBPACK FOOTER //
// ./src/routes/cart/CartIndex.jsx